import { render, staticRenderFns } from "./productionCode.vue?vue&type=template&id=10f0bbdc&scoped=true&"
import script from "./productionCode.vue?vue&type=script&lang=js&"
export * from "./productionCode.vue?vue&type=script&lang=js&"
import style0 from "./productionCode.vue?vue&type=style&index=0&id=10f0bbdc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f0bbdc",
  null
  
)

export default component.exports